import { useEffect, useRef } from 'react';

/**
 * Custom hook that focuses an element when a condition becomes true
 * @param isOpen - Condition that triggers focus (e.g., modal open state)
 * @returns Ref to attach to the element that should receive focus
 */
export function useFocusOnOpen<T extends HTMLElement>(isOpen: boolean) {
  const ref = useRef<T>(null);

  useEffect(() => {
    if (isOpen && ref.current) {
      ref.current.focus();
    }
  }, [isOpen]);

  return ref;
}
